import React, { useState, useRef } from "react";
import axios from "axios";

function FinancialPlanning() {
  const [financeData, setFinanceData] = useState({
    salary: "5700",
    homeLoanDebt: "300000",
    creditCardDebt: "",
    otherDebt: "",
    assets: "20000",
    investments: "",
  });
  const [aiPlan, setAiPlan] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const resultRef = useRef(null);

  const handleChange = (e) => {
    setFinanceData({ ...financeData, [e.target.name]: e.target.value });
  };

  const submitToAI = async () => {
  setLoading(true);
  setError("");
  setAiPlan("");

  try {
    const res = await axios.post("http://localhost:5001/api/financial-plan", financeData);
    setAiPlan(res.data.result);

    // Wait a tiny bit for the render
    setTimeout(() => {
      resultRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);

  } catch (err) {
    setError("Something went wrong. Try again later.");
  }

  setLoading(false);
};


  return (
    <div style={styles.container}>

      {["salary", "homeLoanDebt", "creditCardDebt", "otherDebt", "assets", "investments"].map((field) => (
        <label key={field} style={styles.label}>
          {field.replace(/([A-Z])/g, " $1").replace(/^./, s => s.toUpperCase())}:
          <input
            type="number"
            name={field}
            value={financeData[field]}
            onChange={handleChange}
            style={styles.input}
          />
        </label>
      ))}

      <button onClick={submitToAI} style={styles.button} disabled={loading}>
        {loading ? "Generating..." : "Get AI Financial Plan"}
      </button>

      {error && <p style={styles.error}>{error}</p>}

      {loading && (
  <div style={styles.modalOverlay}>
    <div style={styles.modalContent}>
      <img src="/A.I-2.gif" alt="Loading..." style={styles.loader} />
      <p style={{ color: "#fff", marginTop: 10 }}>Analyzing your finances...</p>
    </div>
  </div>
)}

{aiPlan && (
  <div ref={resultRef} style={styles.result}>
    <h2>*** AI can make mistakes. Check important info. ***</h2>
    <br />
    <h2>Your AI Financial Plan</h2>
    <br />
    <pre style={styles.pre}>{aiPlan}</pre>
  </div>
)}

    </div>
  );
}

const styles = {
  container: {
    maxWidth: 600,
    margin: "30px auto",
    padding: 20,
    fontFamily: "Arial, sans-serif",
    border: "1px solid #ddd",
    borderRadius: 8,
    backgroundColor: "#f9f9f9",
  },
  label: {
    display: "block",
    marginBottom: 15,
    fontWeight: "600",
  },
  input: {
    width: "100%",
    padding: "8px",
    marginTop: 5,
    fontSize: 16,
    borderRadius: 4,
    border: "1px solid #ccc",
  },
  button: {
    padding: "10px 20px",
    fontSize: 16,
    borderRadius: 5,
    border: "none",
    backgroundColor: "#007bff",
    color: "#fff",
    cursor: "pointer",
    marginTop: 10,
  },
  error: {
    color: "red",
    marginTop: 10,
  },
  result: {
    marginTop: 30,
    backgroundColor: "#fff",
    padding: 15,
    borderRadius: 8,
    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
  },
  pre: {
    whiteSpace: "pre-wrap",
    fontFamily: "inherit",
  },
  modalOverlay: {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  backdropFilter: "blur(6px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
},
modalContent: {
  backgroundColor: "rgba(20, 20, 60, 0.85)",
  padding: 40,
  borderRadius: 10,
  textAlign: "center",
  boxShadow: "0 0 20px rgba(0,0,0,0.2)",
},
loader: {
  width: 500,
  height: 300,
},
};

export default FinancialPlanning;